import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { faCircle, faCircleExclamation, faHourglass1 } from '@fortawesome/free-solid-svg-icons';

export const accordionConfig = {
  color: {
    error: tsoPqTheme.palette.customError.color_signal_error_error_bg_dark,
    warning: tsoPqTheme.palette.customInformation.color_signal_warning_warning,
    success: tsoPqTheme.palette.customInformation.color_signal_success_success_bg_dark,
    inProgress: tsoPqTheme.palette.customInformation.color_signal_information_information_bg_dark,
    onHold: tsoPqTheme.palette.customTextColor.color_neutral_font_ft_ntrl_accent,
    default: tsoPqTheme.palette.customTextColor.color_neutral_font_ft_ntrl_accent,
  },
  icon: {
    error: faCircleXmark,
    warning: faCircleExclamation,
    success: faCircleCheck,
    inProgress: faHourglass1,
    onHold: faCircle,
    default: faCircle,
  },
};
